import { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import WeatherWidget from "../../components/WeatherWidget";
import CustomAppBar from "../../components/AppBar";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { useTranslation } from "react-i18next";
import QuickLinks from "../../components/QuickLinks";
import getQuickLinks from "../../Data/iconsData";
import { getBiocharPlants } from "../../api/biocharPlant";

const PlantInchargeDashboard = () => {
  const { t } = useTranslation();
  const [plantDetails, setPlantDetails] = useState({});
  const quickLinksData = getQuickLinks("plant_incharge");

  const fetchPlantDetails = async () => {
    try {
      const response = await getBiocharPlants();
      setPlantDetails(response);
    } catch (error) {
      console.error("Error Fetching VLE Details:", error);
    }
  };

  useEffect(() => {
    fetchPlantDetails();
  }, []);

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <WeatherWidget />
        <Box mt={2}>
          <CustomDashboardCard
            title={t("Total Plants")}
            data={plantDetails.length || 0}
          />
        </Box>
        <Box mt={2}>
          <QuickLinks data={quickLinksData} />
        </Box>
      </Container>
    </>
  );
};

export default PlantInchargeDashboard;
